module.exports = __webpack_public_path__ + "img/location_city.2e8cde87.svg";